import React from "react";
import { Input } from "@/components/ui/input";

const fmt = (v) => (v == null || v === "" ? "" : Number(v).toLocaleString("es-CL", { maximumFractionDigits: 0 }));

export default function MoneyInput({ value, onChange, ...props }) {
  return (
    <Input
      type="text"
      inputMode="numeric"
      value={fmt(value)}
      onChange={(e) => {
        let digits = e.target.value.replace(/\D/g, "");
        const prev = value == null ? "" : String(value);
        if (digits === prev && e.target.value.length < fmt(value).length) {
          const before = e.target.value.slice(0, e.target.selectionStart ?? e.target.value.length).replace(/\D/g, "").length;
          digits = before > 0 ? digits.slice(0, before - 1) + digits.slice(before) : digits;
        }
        onChange(digits ? Number(digits) : null);
      }}
      {...props}
    />
  );
}
